import {axios} from '@/utils/request'

const api = {
  register:'/vis/devices/register',
  bigscreen: '/huayun-vis/vis/devices/status',
}

export function fetchToken(sn) {
  return axios({
    url: api.register,
    method: 'post',
    params: {
      serialNo:sn
    },
    data: {sn: sn}
  })
}

//大屏数据字典
export function bigscreenList(parameter) {
  return axios({
    url: api.bigscreen,
    method: 'get',
    params: parameter
  })
}

//事件滚动数据
export function andonEvtRecList(parameter) {
  return axios({
    url: '/huayun-erp/andon/evt/rec/list',
    method: 'get',
    params: parameter
  })
}
//设备状态滚动数据
export function andonEcqDeviceQueryList(parameter) {
  return axios({
    url: '/huayun-erp/andon/ecq/device/query',
    method: 'get',
    params: parameter
  })
}


export function deviceQuery(data) {
  return axios({
    url: '/huayun-mes/api/mes/production/order/device/query',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/bigscreen/bigscreen.js